"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mongoose = tslib_1.__importStar(require("mongoose"));
const GeoJSON_1 = require("./GeoJSON");
exports.freeReportIds = [
    'MDYwMzc3MDIyMDE1',
    'MDgwMzEwMDE2MDAy',
    'MjUwMTczNTQxMDA0',
    'MDYwODE2MTAzMDM0'
];
exports.getFreeReportId = () => exports.freeReportIds[Math.floor(Math.random() * exports.freeReportIds.length)];
class ILieuucationProperties {
}
exports.ILieuucationProperties = ILieuucationProperties;
const lieuucationSchema = new mongoose.Schema({
    name: {
        type: String,
        index: true,
        trim: true
    },
    internalIds: [{ type: String, index: true }],
    county: {
        type: String,
        index: true,
        trim: true
    },
    state: {
        type: String,
        index: true,
        trim: true
    },
    cbsa: {
        type: String,
        index: true,
        trim: true
    },
    zip: {
        type: String,
        index: true,
        trim: true
    },
    lieuucationZip: {
        type: mongoose.Schema.Types.ObjectId,
        index: true,
        ref: 'LieuucationZip'
    },
    lieuucationCbsa: {
        type: mongoose.Schema.Types.ObjectId,
        index: true,
        ref: 'LieuucationCbsa'
    },
    lieuucationState: {
        type: mongoose.Schema.Types.ObjectId,
        index: true,
        ref: 'LieuucationState'
    },
    lieuucationCountry: {
        type: mongoose.Schema.Types.ObjectId,
        index: true,
        ref: 'LieuucationCountry'
    },
    centLon: {
        type: Number,
        index: true
    },
    centLat: {
        type: Number,
        index: true
    },
    version: {
        type: String,
        index: true
    },
    properties: Object,
    featureCollection: GeoJSON_1.FeatureCollection
}, {
    timestamps: true
});
const v1LieuucationModel = mongoose.model('Lieuucation', lieuucationSchema);
exports.v1LieuucationModel = v1LieuucationModel;
//# sourceMappingURL=Lieuucation.model.js.map